import { SxProps, Theme } from "@mui/material";

// Single source of truth for form-field look (reference: "Category name" / "National" in category AddModal).
export const FIELD_HEIGHT = 40;
export const FIELD_FOCUS_COLOR = "#ba2156";
const FIELD_RADIUS = "6px";
const FIELD_PADDING_X = "11px";

const ERROR_COLOR = "#ff4d4f";

export const fieldRootSx: SxProps<Theme> = {
  height: FIELD_HEIGHT,
  borderRadius: FIELD_RADIUS,
  fontSize: "14px",
  backgroundColor: "background.paper",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--app-border)",
    borderRadius: FIELD_RADIUS,
    // MUI offsets the outline 5px up to make room for the label notch; with the legend hidden
    // that leaves the border taller than the background, so pin it to the field box.
    top: 0,
    "& legend": { display: "none" },
  },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FIELD_FOCUS_COLOR },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: FIELD_FOCUS_COLOR,
    borderWidth: "1px",
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: ERROR_COLOR },
  "& .MuiOutlinedInput-input": {
    height: "100%",
    boxSizing: "border-box",
    padding: `4px ${FIELD_PADDING_X}`,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    height: "100%",
    boxSizing: "border-box",
    padding: `4px ${FIELD_PADDING_X}`,
  },
};
